export { tabCss, headerCss, sectionCss, DragHandle, ExpandedCard, ExpandedCardHeader, ExpandedCardBody, ExpandedCardFooter, CardContent } from '../confirmation/styles';
export const questionListCss = "q6zniqx";
export const systemQuestionRowCss = "s1jaj4ld";
export const systemQuestionRowInteractiveCss = "sd93ngl";
export const systemQuestionLeadingCss = "sf8lyt7";
export const decorativeDragIconCss = "d1ak76ap";
export const systemQuestionLabelCss = "shf99mu";
export const customQuestionCollapsedCss = "c19qn800";
export const customQuestionLeadingControlCss = "c16awodv";
export const customQuestionContentCss = "c13fmijj";
export const customQuestionClickTargetCss = "c24vs12";
export const choicePreviewListCss = "c6xac20";
export const choicePreviewItemCss = "c17pm3k6";
export const questionTypeBadgeRowCss = "q8m5dl6";
export const expandedCardSettingSectionCss = "e8p1kl6";
export const expandedCardBodyWithSectionsCss = "em8o6q";

/* Match body/settings inset (spacing1x) so the type control lines up with
 * Question * and Required — not pulled left of that content column. */
export const expandedCardFooterWithTypeCss = "ezldlkj";
export const questionTypeMenuTriggerWrapCss = "q1f55lhe";
export const expandedCardFooterActionsCss = "e1matf57";
export const answerChoicesSectionCss = "a1s5savb";
export const answerChoiceRowCss = "ayh0her";
export const answerChoiceControlCss = "ajv3wo5";
export const answerChoiceFieldCss = "a1tx867f";
export const addChoiceButtonCss = "a15ey52r";
export const newQuestionButtonCss = "n1k35vj2";

/** Figma question-type menu width (2737:227701 → Menu w-[397px]). */
const QUESTION_TYPE_MENU_WIDTH_PX = 397;
export const questionTypeMenuContentCss = "q3r2kcb";
export const questionTypeMenuStyle = {
  width: QUESTION_TYPE_MENU_WIDTH_PX,
  minWidth: QUESTION_TYPE_MENU_WIDTH_PX,
  maxWidth: QUESTION_TYPE_MENU_WIDTH_PX
};
export const questionTypeMenuGroupTitleCss = "qrmul4h";
export const questionTypeMenuItemContentCss = "q1un3xjs";
export const questionTypeMenuItemTitleRowCss = "qafqbo9";
export const questionTypeMenuItemDescriptionRowCss = "q18s6j3";
export const questionTypeMenuItemIconSpacerCss = "q17kwd1l";
export const nameFormatOptionsCss = "ngbr6vr";
export const expandedCardHeaderTitleCss = "ekfdh4r";
export const lockedQuestionsListCss = "lo9h0zy";

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");